import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { a as EGDSButton, E as EGDSButtonSize } from '../paging-button/index-chunk.esm.js';
import { E as EGDSPrimaryButton } from '../primary-button/index-chunk.esm.js';

class EGDSFloatingFullWidthButton extends React.Component {
    static displayName = 'EGDSFloatingFullWidthButton';
    render() {
        const { props } = this;
        const cssClassNames = classNames(`${EGDSButton.baseClassName}-floating-full-width`, props.className);
        return (jsx(EGDSPrimaryButton, { size: EGDSButtonSize.LARGE, isFullWidth: true, ...props, className: cssClassNames }));
    }
}

export { EGDSFloatingFullWidthButton as E };
//# sourceMappingURL=index-chunk.esm.js.map
